import { postJson } from "../methods";
function viewSearch({ offset = 0, size = 12 }, headers = {}) {
  const payload = {
    offset,
    rules: [
      ["order_by", "rank", "desc"],
      ["order_by", "create_date", "asc"]
    ],
    size
  };
  return postJson({
    url: "api/grid/view/search",
    headers,
    payload
  });
}
export {
  viewSearch as default
};
